// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var JsxRuntime = require("react/jsx-runtime");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var ColorPicker$ReactHooksTemplate = require("../common/ColorPicker.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

var scaleOptions = Belt_Array.range(StarRating$ReactHooksTemplate.minScale, StarRating$ReactHooksTemplate.maxScale);

function rangesOverlap(left, right) {
  if (left.min <= right.max) {
    return right.min <= left.max;
  } else {
    return false;
  }
}

function isValidRange(ranges, rangeIndex, min, max) {
  if (min > max) {
    return false;
  }
  var candidate = {
    min: min,
    max: max,
    color: ""
  };
  return !Belt_List.some(Belt_List.mapWithIndex(ranges, (function (index, other) {
                    if (index !== rangeIndex) {
                      return rangesOverlap(candidate, other);
                    } else {
                      return false;
                    }
                  })), (function (overlaps) {
                return overlaps;
              }));
}

function rangeOverlapsAnother(ranges, rangeIndex) {
  var current = Belt_List.get(ranges, rangeIndex);
  if (current !== undefined) {
    return Belt_List.some(Belt_List.mapWithIndex(ranges, (function (index, other) {
                      if (index !== rangeIndex) {
                        return rangesOverlap(current, other);
                      } else {
                        return false;
                      }
                    })), (function (overlaps) {
                  return overlaps;
                }));
  } else {
    return false;
  }
}

function validFromOptions(ranges, rangeIndex, scaleMin, scaleMax) {
  var range = Belt_List.get(ranges, rangeIndex);
  if (range !== undefined) {
    return Belt_List.keep(Belt_List.fromArray(Belt_Array.range(scaleMin, scaleMax)), (function (value) {
                  if (value <= range.max) {
                    return isValidRange(ranges, rangeIndex, value, range.max);
                  } else {
                    return false;
                  }
                }));
  } else {
    return /* [] */0;
  }
}

function validToOptions(ranges, rangeIndex, scaleMin, scaleMax) {
  var range = Belt_List.get(ranges, rangeIndex);
  if (range !== undefined) {
    return Belt_List.keep(Belt_List.fromArray(Belt_Array.range(scaleMin, scaleMax)), (function (value) {
                  if (value >= range.min) {
                    return isValidRange(ranges, rangeIndex, range.min, value);
                  } else {
                    return false;
                  }
                }));
  } else {
    return /* [] */0;
  }
}

function findNextUncoveredValue(ranges, minRating, maxRating) {
  var isCovered = function (value) {
    return Belt_List.some(ranges, (function (range) {
                  if (value >= range.min) {
                    return value <= range.max;
                  } else {
                    return false;
                  }
                }));
  };
  var _value = minRating;
  while(true) {
    var value = _value;
    if (value > maxRating) {
      return ;
    }
    if (!isCovered(value)) {
      return value;
    }
    _value = value + 1 | 0;
    continue ;
  };
}

function StarRatingEditor(props) {
  var onStarRatingChange = props.onStarRatingChange;
  var starRating = props.starRating;
  var scaleMin = StarRating$ReactHooksTemplate.minRating(starRating);
  var scaleMax = StarRating$ReactHooksTemplate.maxRating(starRating);
  var ranges = StarRating$ReactHooksTemplate.colorRanges(starRating);
  var canAddRange = Belt_Option.isSome(findNextUncoveredValue(ranges, scaleMin, scaleMax));
  var renderBoundarySelect = function (label, currentValue, options, onSelect) {
    var options$1 = Belt_List.some(options, (function (value) {
            return value === currentValue;
          })) ? options : ({
          hd: currentValue,
          tl: options
        });
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("label", {
                        children: label,
                        className: "block text-xs text-gray-500 mb-1"
                      }),
                  JsxRuntime.jsx("select", {
                        children: $$Array.of_list(Belt_List.map(options$1, (function (value) {
                                    return JsxRuntime.jsx("option", {
                                                children: String(value),
                                                value: String(value)
                                              }, String(value));
                                  }))),
                        className: "w-16 border border-gray-300 rounded-md px-2 py-1.5 text-sm bg-white focus:border-gray-500 focus:outline-none",
                        value: String(currentValue),
                        onChange: (function ($$event) {
                            Curry._1(onSelect, Caml_format.int_of_string($$event.target.value));
                          })
                      })
                ],
                className: "flex-shrink-0"
              });
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h4", {
                              children: "Rating scale",
                              className: "text-sm font-semibold text-gray-800 mb-4"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Minimum",
                                              className: "block text-xs font-medium text-gray-600 mb-1"
                                            }),
                                        JsxRuntime.jsx("select", {
                                              children: Belt_Array.map(scaleOptions, (function (option) {
                                                      return JsxRuntime.jsx("option", {
                                                                  children: String(option),
                                                                  value: String(option)
                                                                }, String(option));
                                                    })),
                                              className: "w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white focus:border-gray-500 focus:outline-none",
                                              value: String(StarRating$ReactHooksTemplate.minRating(starRating)),
                                              onChange: (function ($$event) {
                                                  var value = Caml_format.int_of_string($$event.target.value);
                                                  Curry._1(onStarRatingChange, StarRating$ReactHooksTemplate.setMinRating(starRating, value));
                                                })
                                            })
                                      ],
                                      className: "flex-1 min-w-0"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Maximum",
                                              className: "block text-xs font-medium text-gray-600 mb-1"
                                            }),
                                        JsxRuntime.jsx("select", {
                                              children: Belt_Array.map(scaleOptions, (function (option) {
                                                      return JsxRuntime.jsx("option", {
                                                                  children: String(option),
                                                                  value: String(option)
                                                                }, String(option));
                                                    })),
                                              className: "w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white focus:border-gray-500 focus:outline-none",
                                              value: String(StarRating$ReactHooksTemplate.maxRating(starRating)),
                                              onChange: (function ($$event) {
                                                  var value = Caml_format.int_of_string($$event.target.value);
                                                  Curry._1(onStarRatingChange, StarRating$ReactHooksTemplate.setMaxRating(starRating, value));
                                                })
                                            })
                                      ],
                                      className: "flex-1 min-w-0"
                                    })
                              ],
                              className: "flex gap-3 mb-5 w-full"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("h5", {
                                              children: "Color ranges",
                                              className: "text-xs font-semibold text-gray-700 uppercase tracking-wide"
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: "+ Add range",
                                              className: canAddRange ? "text-xs text-blue-600 hover:text-blue-800 font-medium whitespace-nowrap ml-2" : "text-xs text-gray-400 font-medium whitespace-nowrap ml-2 cursor-not-allowed",
                                              title: canAddRange ? "Add a color band for the next uncovered rating on the scale" : "Every rating is already covered. Shrink a range's \"To\" value first to add another band.",
                                              disabled: !canAddRange,
                                              type: "button",
                                              onClick: (function (param) {
                                                  if (canAddRange) {
                                                    var nextMin = findNextUncoveredValue(ranges, scaleMin, scaleMax);
                                                    if (nextMin === undefined) {
                                                      return ;
                                                    }
                                                    var newRange = {
                                                      min: nextMin,
                                                      max: nextMin,
                                                      color: "#7E909A"
                                                    };
                                                    return Curry._1(onStarRatingChange, StarRating$ReactHooksTemplate.setColorRanges(starRating, Belt_List.concatMany([
                                                                        ranges,
                                                                        {
                                                                          hd: newRange,
                                                                          tl: /* [] */0
                                                                        }
                                                                      ])));
                                                  }
                                                  
                                                })
                                            })
                                      ],
                                      className: "flex items-center justify-between mb-2"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Assign a color to each rating with non-overlapping bands (e.g. 1–2 red, 3–4 yellow, 5–10 gray). Each number can belong to only one range.",
                                      className: "text-xs text-gray-500 mb-3 leading-relaxed"
                                    }),
                                canAddRange ? null : JsxRuntime.jsx("p", {
                                        children: "All ratings on this scale already have a color range. To add another band, lower the \"To\" value on an existing range so there is a gap, then click Add range.",
                                        className: "text-xs text-gray-400 mb-3 leading-relaxed"
                                      }),
                                JsxRuntime.jsx("div", {
                                      children: $$Array.of_list(Belt_List.mapWithIndex(ranges, (function (index, range) {
                                                  var fromOptions = validFromOptions(ranges, index, scaleMin, scaleMax);
                                                  var toOptions = validToOptions(ranges, index, scaleMin, scaleMax);
                                                  var hasOverlap = rangeOverlapsAnother(ranges, index);
                                                  return JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        JsxRuntime.jsx("span", {
                                                                              children: "Range " + String(index + 1 | 0),
                                                                              className: "text-xs font-medium text-gray-600"
                                                                            }),
                                                                        JsxRuntime.jsx("button", {
                                                                              children: "Remove",
                                                                              className: "text-xs text-red-600 hover:text-red-800 font-medium px-2 py-1 rounded hover:bg-red-50",
                                                                              type: "button",
                                                                              onClick: (function (param) {
                                                                                  if (Belt_List.length(ranges) <= 1) {
                                                                                    return ;
                                                                                  }
                                                                                  var updated = Belt_List.keepWithIndex(ranges, (function (param, i) {
                                                                                          return i !== index;
                                                                                        }));
                                                                                  Curry._1(onStarRatingChange, StarRating$ReactHooksTemplate.setColorRanges(starRating, updated));
                                                                                })
                                                                            })
                                                                      ],
                                                                      className: "flex items-center justify-between mb-3"
                                                                    }),
                                                                hasOverlap ? JsxRuntime.jsx("p", {
                                                                        children: "This range overlaps another. Adjust From/To so bands do not share ratings — only non-overlapping values can be selected.",
                                                                        className: "text-xs text-red-600 mb-3 leading-relaxed"
                                                                      }) : null,
                                                                JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        renderBoundarySelect("From", range.min, fromOptions, (function (value) {
                                                                                var range = Belt_List.get(ranges, index);
                                                                                if (range === undefined) {
                                                                                  return ;
                                                                                }
                                                                                if (!isValidRange(ranges, index, value, range.max)) {
                                                                                  return ;
                                                                                }
                                                                                var updated = Belt_List.mapWithIndex(ranges, (function (index$1, current) {
                                                                                        if (index$1 === index) {
                                                                                          return {
                                                                                                  min: value,
                                                                                                  max: current.max,
                                                                                                  color: current.color
                                                                                                };
                                                                                        } else {
                                                                                          return current;
                                                                                        }
                                                                                      }));
                                                                                Curry._1(onStarRatingChange, StarRating$ReactHooksTemplate.setColorRanges(starRating, updated));
                                                                              })),
                                                                        JsxRuntime.jsx("span", {
                                                                              children: "to",
                                                                              className: "text-gray-400 text-sm pt-5 flex-shrink-0"
                                                                            }),
                                                                        renderBoundarySelect("To", range.max, toOptions, (function (value) {
                                                                                var range = Belt_List.get(ranges, index);
                                                                                if (range === undefined) {
                                                                                  return ;
                                                                                }
                                                                                if (!isValidRange(ranges, index, range.min, value)) {
                                                                                  return ;
                                                                                }
                                                                                var updated = Belt_List.mapWithIndex(ranges, (function (index$1, current) {
                                                                                        if (index$1 === index) {
                                                                                          return {
                                                                                                  min: current.min,
                                                                                                  max: value,
                                                                                                  color: current.color
                                                                                                };
                                                                                        } else {
                                                                                          return current;
                                                                                        }
                                                                                      }));
                                                                                Curry._1(onStarRatingChange, StarRating$ReactHooksTemplate.setColorRanges(starRating, updated));
                                                                              }))
                                                                      ],
                                                                      className: "flex items-center gap-2 mb-3 w-full"
                                                                    }),
                                                                JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        JsxRuntime.jsx("label", {
                                                                              children: "Color",
                                                                              className: "block text-xs text-gray-500 mb-2"
                                                                            }),
                                                                        JsxRuntime.jsx(ColorPicker$ReactHooksTemplate.make, {
                                                                              value: range.color,
                                                                              onChange: (function (color) {
                                                                                  var updated = Belt_List.mapWithIndex(ranges, (function (index$1, range) {
                                                                                          if (index$1 === index) {
                                                                                            return {
                                                                                                    min: range.min,
                                                                                                    max: range.max,
                                                                                                    color: color
                                                                                                  };
                                                                                          } else {
                                                                                            return range;
                                                                                          }
                                                                                        }));
                                                                                  Curry._1(onStarRatingChange, StarRating$ReactHooksTemplate.setColorRanges(starRating, updated));
                                                                                }),
                                                                              ariaLabel: "Pick color for range " + String(index + 1 | 0)
                                                                            })
                                                                      ],
                                                                      className: "w-full"
                                                                    })
                                                              ],
                                                              className: "w-full bg-white rounded-md border p-3 overflow-hidden " + (
                                                                hasOverlap ? "border-red-300" : "border-gray-200"
                                                              )
                                                            }, String(index));
                                                }))),
                                      className: "w-full space-y-3"
                                    })
                              ],
                              className: "w-full"
                            })
                      ],
                      className: "mt-4 border border-gray-200 rounded-lg p-4 bg-gray-50 w-full"
                    })
              ],
              className: "w-full"
            });
}

var make = StarRatingEditor;

exports.scaleOptions = scaleOptions;
exports.rangesOverlap = rangesOverlap;
exports.isValidRange = isValidRange;
exports.rangeOverlapsAnother = rangeOverlapsAnother;
exports.validFromOptions = validFromOptions;
exports.validToOptions = validToOptions;
exports.findNextUncoveredValue = findNextUncoveredValue;
exports.make = make;
/* scaleOptions Not a pure module */
